import axios from 'axios';
import { getUrl } from './utils/utils';
import * as localstorageUtil from './utils/localstorage';
import LOCAL_STORAGE from './constants/localStorage';
import { SERVICE_NAMES } from './constants/appConstant';

function getRequestLocation() {
  const originUrl = window.location.href.split(window.location.origin);
  if (Array.isArray(originUrl) && originUrl.length >= 1) {
    return originUrl[1];
  }

  return null;
}

const result = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});
result.interceptors.request.use(
  function(config) {
    const token = localstorageUtil.getItem('token');
    let requestOriginLocation = getRequestLocation();
    if (requestOriginLocation) {
      config.headers['Request-Route-Origin'] = getRequestLocation();
    }
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    const appSlaveId = localstorageUtil.getItem(LOCAL_STORAGE.SLAVE_ID);
    if (appSlaveId) {
      config.headers['App-Slave-ID'] = appSlaveId;
    } else {
      config.headers['App-Slave-ID'] = '';
    }
    config.baseURL = `${getUrl()}/api`;
    return config;
  },
  function(error) {
    return Promise.reject(error);
  },
);

result.interceptors.response.use(
  function(response) {
    return response.data;
  },
  function(error) {
    const { response, config } = error;
    if (response) {
      let showToast = true;
      const { status, data } = response;
      if (status === 401 && data && data.message == 'PROXY_UNAUTHORIZED') {
        localstorageUtil.clear();
        window.location.href = 'login';
      }
      if (status === 401 && data && data.message === `SERVICE_UNAUTHORIZED:${SERVICE_NAMES.RUBIX_SERVICE}`) {
        showToast = false;
        window.EventBus.$emit('show-reconfigure-services', { [SERVICE_NAMES.RUBIX_SERVICE]: false });
      }
      if (status === 401 && data && data.message === `SERVICE_UNAUTHORIZED:${SERVICE_NAMES.RUBIX_BIOS}`) {
        showToast = false;
        window.EventBus.$emit('show-reconfigure-services', { [SERVICE_NAMES.RUBIX_BIOS]: false });
      }
      if (status === 403) {
        window.location.href = '/exception-403';
      }
      if (!config.restrictToast && showToast) {
        window.EventBus.$emit('show-toast', data.message);
      }
      window.EventBus.$emit('change-loading', false);
      const logs = JSON.parse(localstorageUtil.getItem('logs')) || [];
      const log = { time: new Date().getTime(), message: data.message };
      if (data.description) {
        log.description = data.description;
      }
      const existingLogs = logs.find(l => {
        let result = l.message === data.message;
        if (l.description) {
          result &= l.description === data.description;
        }
        return result;
      });
      if (!existingLogs || existingLogs.length === 0) {
        logs.push(log);
      }
      localstorageUtil.setItem('logs', JSON.stringify(logs));
      return Promise.reject(data);
    }
    return Promise.reject(error);
  },
);

export default result;
